import { connect } from 'react-redux';
import withState from 'recompose/withState';
import compose from 'recompose/compose';
import History from '../components/History';
import {
  getPayoutReportHistory,
} from '../../../../main/reports/selectors';

const mapStateToProps = state => ({
  summary: state.reports.payoutHistory.summary,
  history: getPayoutReportHistory(state),
});

const enhance = compose(
  connect(mapStateToProps),
  withState('showHistory', 'setShowHistory', false),
  withState('expanded', 'setExpanded', {})
);

export default enhance(History);
